import { AppStateService, Component } from "../../../core/index";
import { ApplePayButtonLocale } from "@bambora/wallet/dist/types/clients/applepay";

import { States } from "../../../app.states";
import { WalletService } from "../../index";
import base from "../../../styles/base.scss";
import buttons from "../../../styles/buttons.scss";
import applepay from "./applepay-start.scss";
import template from "./applepay-start.html";

const styles = { base, buttons, applepay };


@Component({
    selector: "becApplePayStart",
    template
})
export class ApplePayStart {
    styles = styles;
    paymentTypeName = "ApplePay";

    static $inject = [
        "WalletService", "gettextCatalog", "AppStateService"
    ];

    constructor(
        private walletService: WalletService,
        private gettextCatalog: ng.gettext.gettextCatalog,
        public appState: AppStateService
    ) { }

    $onInit() {
        if (this.walletService.isApplePayAvailable) {
            const container = document.getElementById("applePayButtonContainer");

            this.walletService.applePayWallet.createButton(container, {
                buttonLocale: this.gettextCatalog.getCurrentLanguage() as ApplePayButtonLocale,
                buttonStyle: "black",
                buttonType: "plain",
                onClick: () => this.walletService.openWallet("expressoption", this.walletService.applePayWallet.start, States.Session.ApplePay.Accept.name)
            });
        }
    }
}
